import { JSX, useState } from "react";
import { ProductFilterGroupInterface } from "../../../common/interfaces/apiV2/product/ProductFilterOptionsInterface";
import { selectFilter } from "../ProductRangeSlice";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { ProductFilter } from "@hatch-digital-nl/bravilor-storybook";

interface Props {
    filter: ProductFilterGroupInterface;
}

export const ProductFilterWrapper = (props: Props): JSX.Element | null => {
    const dispatch = useAppDispatch();

    const [active, setActive] = useState(true);

    const { selectedFilters } = useAppSelector((state) => state.productRange);
    const { filter } = props;

    const selectedOptionsForThisFilter =
        selectedFilters[filter.id]?.options || [];

    const transformedFilter = {
        id: filter.id,
        code: filter.code,
        label: filter.label ?? "",
        filterTooltip: filter.filterTooltip ?? undefined,
        options: [...filter.options]
            .sort((a, b) => a.sort - b.sort)
            .map((option) => ({
                id: String(option.id),
                label: option.label ?? "",
                value: option.id,
                sort: option.sort,
            })),
    };

    const handleOptionChange = (optionId: string): void => {
        const option = filter.options.find(
            (opt) => String(opt.id) === optionId,
        );

        if (option) {
            dispatch(
                selectFilter({
                    filter,
                    option: { id: optionId },
                }),
            );
        }
    };

    if (!filter) {
        return null;
    }

    return (
        <ProductFilter
            filter={transformedFilter}
            isActive={active}
            selectedOptions={selectedOptionsForThisFilter}
            onOptionChange={(optionId: string) => {
                handleOptionChange(optionId);
            }}
            onToggle={() => setActive(!active)}
        />
    );
};

export const ProductFilterSkeleton = (): JSX.Element => {
    return (
        <div className="c-product-filters__filter is-active">
            <div className="c-product-filters__filter__header">
                <div className="c-product-filters__filter__header__title">
                    <span className="skeleton skeleton-name"></span>
                </div>
                <div className="c-product-filters__filter__header__icon">
                    <span></span>
                    <span></span>
                </div>
            </div>

            <div className="c-product-filters__filter__options">
                {Array(5)
                    .fill(0)
                    .map((_, index) => (
                        <label
                            key={index}
                            className="skeleton-input c-product-filters__filter__option"
                        >
                            <input type="checkbox" className="checkbox" />
                            <span className="skeleton skeleton-input-option"></span>
                        </label>
                    ))}
            </div>
        </div>
    );
};
